export default "__VITE_ASSET__54e60c3b__"